import { Action, ControlType } from "@/context/AnalyticsProvider";
import type { GamePageEvent } from "@/context/AnalyticsProvider/gamePage";
import { GamePageSection } from "@/context/AnalyticsProvider/gamePage";

export const TermsAndPrivacy = ({
  track,
}: { track: (event: GamePageEvent) => void }) => {
  const handleTermsClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    track({
      action: Action.PRESSED,
      extras: {
        control: "terms-of-service",
        controlLabel: "Terms of Service",
        controlType: ControlType.LINK,
        section: GamePageSection.ONBOARDING_MODAL,
      },
    });

    window.open("https://www.immutable.com/legal/terms-of-service", "_blank");
  };

  const handlePrivacyPolicyClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    track({
      action: Action.PRESSED,
      extras: {
        control: "privacy-policy",
        controlLabel: "Privacy Policy",
        controlType: ControlType.LINK,
        section: GamePageSection.ONBOARDING_MODAL,
      },
    });

    window.open("https://www.immutable.com/legal/privacy-policy", "_blank");
  };

  const handleCollectionStatementClick = (
    e: React.MouseEvent<HTMLAnchorElement>,
  ) => {
    e.preventDefault();
    track({
      action: Action.PRESSED,
      extras: {
        control: "collection-statement",
        controlLabel: "Collection Statement",
        controlType: ControlType.LINK,
        section: GamePageSection.ONBOARDING_MODAL,
      },
    });

    window.open(
      "https://www.immutable.com/legal/collection-statement",
      "_blank",
    );
  };

  return (
    <p className="text-muted-foreground leading-snug text-left text-[0.625rem]">
      By continuing, you agree to our{" "}
      <a
        href="https://www.immutable.com/legal/terms-of-service"
        target="_blank"
        rel="noreferrer"
        data-testid="terms"
        className="text-muted-foreground underline underline-offset-1 hover:text-white transition-colors"
        onClick={handleTermsClick}
      >
        Terms of Service
      </a>
      , and acknowledge you have understood our{" "}
      <a
        href="https://www.immutable.com/legal/privacy-policy"
        target="_blank"
        rel="noreferrer"
        className="text-muted-foreground underline underline-offset-1 hover:text-white transition-colors"
        onClick={handlePrivacyPolicyClick}
      >
        Privacy Policy
      </a>{" "}
      and{" "}
      <a
        href="https://www.immutable.com/legal/collection-statement"
        target="_blank"
        rel="noreferrer"
        className="text-muted-foreground underline underline-offset-1 hover:text-white transition-colors"
        onClick={handleCollectionStatementClick}
      >
        Collection Statement
      </a>
      .
    </p>
  );
};
